import { colors } from '@/plugins/vuetify'
import moment from 'moment'
import tinygradient from 'tinygradient'

export function useRatingColors() {
  function getRanges(inverse = false) {
    /*
    if (inverse) {
      return [0, 0.15, 0.2, 0.3, 0.5, 0.7, 0.8, 1]
    } else {
      return [0, 0.01, 0.15, 0.2, 0.3, 0.5, 0.7, 0.8, 1]
    }
    */
    return [0, 0.2, 0.5, 0.8, 1]
  }

  function getExtendedRanges(inverse = false) {
    return [0, 0.25, 0.5, 0.65, 0.8, 0.85, 0.9, 0.95, 1]
  }

  function getColor(value: number, maxValue = 1, inverse = false) {
    /*
     * This is the logic to use new rating colors from wasabi. For now, we will use the current colors to keep colors consistent
    if (!value || !maxValue || value > maxValue) {
      return colors.neutral.neutral200
    }
    value = value / maxValue
    if (inverse) {
      if (value === 0) {
        return colors.green.green500
      } else if (value <= 0.15) {
        return colors.green.green200
      } else if (value <= 0.2) {
        return colors.yellow.yellow600
      } else if (value <= 0.3) {
        return colors.yellow.yellow400
      } else if (value <= 0.5) {
        return colors.coral.coral400
      } else if (value <= 0.7) {
        return colors.coral.coral600
      } else if (value <= 0.8) {
        return colors.red.red400
      } else {
        return colors.red.red600
      }
    } else {
      if (value < 0.01) {
        return colors.neutral.neutral200
      } else if (value < 0.15) {
        return colors.red.red600
      } else if (value < 0.2) {
        return colors.red.red400
      } else if (value < 0.3) {
        return colors.coral.coral600
      } else if (value < 0.5) {
        return colors.coral.coral400
      } else if (value < 0.7) {
        return colors.yellow.yellow400
      } else if (value < 0.8) {
        return colors.yellow.yellow600
      } else if (value < 1) {
        return colors.green.green200
      } else {
        return colors.green.green500
      }
    }
    */
    const rating = Math.round(Number(value))
    switch (rating) {
      case 1:
        return '#b70034'
      case 2:
        return '#f0495d'
      case 3:
        return '#f88245'
      case 4:
        return '#ffbc2b'
      case 5:
        return '#007244'
      default:
        return '#e5e5e5'
    }
  }

  function getLightColor(value: number, maxValue = 5, inverse = false) {
    const rating = Math.round((Number(value) / maxValue) * 5)
    switch (rating) {
      case 1:
      case 2:
        return colors.red.red000
      case 3:
        return colors.coral.coral000
      case 4:
        return colors.yellow.yellow000
      case 5:
        return colors.green.green000
      default:
        return '#E5E5E5'
    }
  }

  function getHeatMapColor(value: number, maxValue = 1, inverse = false) {
    if (value == null || !maxValue || value > maxValue) {
      return '#ececec'
    }

    const heatmapGradient = tinygradient([
      { color: '#b70034', pos: 0 },
      { color: '#f0495d', pos: 0.2 },
      { color: '#f88245', pos: 0.5 },
      { color: '#ffbc2b', pos: 0.8 },
      { color: '#027244', pos: 1 }
    ])
    value = value / maxValue
    const color = heatmapGradient.rgbAt(value)
    return color.toHexString()
  }

  function getScoreColor(value: number, maxValue = 1, inverse = false) {
    if (value == null || !maxValue || value > maxValue) {
      return '#ececec'
    }

    const scoreColors = [
      { score: 0, color: '#ececec' },
      { score: 24, color: '#b70034' },
      { score: 49, color: '#f0495d' },
      { score: 64, color: '#f88245' },
      { score: 79, color: '#ffbc2b' },
      { score: 84, color: '#90CA6D' },
      { score: 89, color: '#77c16b' },
      { score: 94, color: '#5EB768' },
      { score: 99, color: '#009564' },
      { score: 100, color: '#007244' }
    ]

    const color = scoreColors.find((c) => value <= c.score).color
    return color
  }

  const calculateColorClass = (startDate: string, endDate: string): string => {
    const difference = moment(endDate).diff(moment(startDate), 'minutes')
    const score = getScoreFromDiff(difference)
    return getScoreColor(score, 100)
  }

  const getScoreFromDiff = (difference: number): number => {
    let score: number

    if (difference <= 480) {
      score = 100
    } else if (difference <= 720) {
      score = 99
    } else if (difference <= 1200) {
      score = 94
    } else if (difference <= 1320) {
      score = 89
    } else if (difference <= 1440) {
      score = 84
    } else if (difference <= 1680) {
      score = 79
    } else if (difference <= 1820) {
      score = 69
    } else if (difference <= 2000) {
      score = 59
    } else if (difference <= 2240) {
      score = 49
    } else if (difference <= 2880) {
      score = 24
    } else {
      score = 1
    }

    return score
  }

  return {
    getColor,
    getLightColor,
    getRanges,
    getHeatMapColor,
    getExtendedRanges,
    getScoreColor,
    calculateColorClass
  }
}
